module.exports = __webpack_public_path__ + "img/ahly-bank.2724a92c.webp";